<template>
  <div :id="accordionDivId"
       class="lbs-viewer-slide-tray"/>
</template>

<script>
  import { get } from 'lodash';

  export default {
    name: 'SlideTray',
    props: {
      config: {
        type: Object,
        required: true
      }
    },
    computed: {
      accordionDivId () {
        return get(this.config.legacyConfig, 'accordionSettings.divId', 'accordionContainer');
      }
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/slide-tray-workflow/SlideTray.vue